import React from 'react';
import ButtonChatBadge from './ButtonChatBadge';
import ButtonToggleCamera from './ButtonToggleCamera';
import ButtonToggleScreenShare from './ButtonToggleScreenShare';
import ButtonToggleMicrophone from './ButtonToggleMicrophone';
import ButtonToggleMembersList from './ButtonToggleMembersList';
import ButtonHangUp from './ButtonHangUp';
import ButtonOpenCloseJoinInfo from './ButtonOpenCloseJoinInfo';
import ButtonToggleHostControls from './ButtonToggleHostControls';
import ButtonDisplayBackgroundEffectsModal from './ButtonDisplayBackgroundEffectsModal';
import MoreMenu from './more-menu/MoreMenu';
import MeetingDeviceSettingsButton from '../MeetingDeviceSettingsButton';
import { getFooterMenuItemShownClass } from 'flow/utils/meeting-footer-utils';

interface Props {
    openCloseJoinInfo: () => void;
    setElectronScreenShareMenuIsOpen: React.Dispatch<
        React.SetStateAction<boolean>
    >;
}

/**
 * The meeting control footer — one layout for every form factor (fullscreen,
 * one-pane and docked side pane). The primary controls stay in the footer's
 * true center via balanced flex spacers: they re-center as the footer widens
 * and shrink apart without colliding when it narrows. Participants, chat and
 * join-info sit in a cylinder-button group pinned to the end; once the footer
 * is too narrow to hold them (a container query — see meeting-footer-utils)
 * that group collapses into the more-menu, which takes their place at the end.
 */
const MeetingFooterButtons = ({
    openCloseJoinInfo,
    setElectronScreenShareMenuIsOpen,
}: Props) => (
    <div className="flex w-full items-center">
        {/* Start group — mirrors the end group so the primary controls land in
            the footer's true center. (The meeting timestamp/title will also
            live here later.) */}
        <div className="ms-6 flex flex-1 items-center gap-3">
            <MeetingDeviceSettingsButton />
        </div>
        <div className="flex items-center gap-3">
            <ButtonToggleMicrophone />
            <ButtonToggleCamera />
            <ButtonToggleScreenShare
                setElectronScreenShareMenuIsOpen={
                    setElectronScreenShareMenuIsOpen
                }
            />
            <ButtonDisplayBackgroundEffectsModal />
            {/* The more-menu takes the background-effects slot once the footer
                is too narrow: effects (and the end group below) collapse into
                it. Gate visibility on the wrapper so it leaves the flex row
                entirely when hidden — otherwise its empty popover wrapper still
                consumes a gap. */}
            <div className={getFooterMenuItemShownClass()}>
                <MoreMenu openCloseJoinInfo={openCloseJoinInfo} />
            </div>
            <ButtonHangUp />
        </div>
        <div className="me-6 flex flex-1 items-center justify-end gap-3">
            <ButtonToggleMembersList />
            <ButtonToggleHostControls />
            <ButtonChatBadge />
            <ButtonOpenCloseJoinInfo onClick={openCloseJoinInfo} />
        </div>
    </div>
);

export default MeetingFooterButtons;
